import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
import PropTypes from 'prop-types';
import { Slide } from 'pure-react-carousel';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { notMatchremoveTag } from 'lib';


/**
 * Text
 */
const NotMatchCarousel = ({ boxStyle, item, viewType, onClickEvt, listKey }) => {
  const { items, type, id } = item;
  const arr = ['사이트', '메뉴검색', '서식검색', '웹문서', '게시판'];
  const titleBackColor = ['#4a53cd', '#ea3b8d', '#0180a0', '#29308a', '#0099FF'];
  const listIdx = listKey;
  const slideBoxSet = boxStyle;

  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: `270px`,
    marginRight: `${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;

  const constentSet = () => {
    return (
      <div key={`constentSet_${listIdx}`} id={`constentSet_${listIdx}`}>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${listIdx}_${idx}`} className="_notMatch_carousel" style={slideBoxSetStyle}>
              <div className="_notMatch_carousel_div">
                <div className="_notMatch_carousel_title" id={`_notMatch_carousel_${listIdx}_${idx}_title`} style={{ backgroundColor: titleBackColor[idx] }}>
                  <div className="_title" id={`_notMatch_carousel_${listIdx}_${idx}_tit`}>
                    {arr[idx]}
                  </div>
                </div>
                <div className="_notMatch_content">
                  <div className="_notMatch_carousel_content" id={`_notMatch_carousel_${listIdx}_${idx}_content`}>
                    {/* {ReactHtmlParser(tempItem.content.value)} */}
                    {ReactHtmlParser(notMatchremoveTag(tempItem.content.value))}
                  </div>
                </div>
                <div className="_notMatch_plus" />
              </div>
            </Slide>
          );
        })}
      </div>
    );
  };
  return (
    <>
      <div className="_carousel_button_div" key={`cart_${listIdx}`}>
        <CarouselSlider key={`carSlider_${listIdx}`} slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} listIdx={listIdx} />
      </div>
    </>
  );
};
NotMatchCarousel.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
  listKey: PropTypes.string,
};
NotMatchCarousel.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
  listKey: '',
};

export default NotMatchCarousel;